import React from 'react';
import { Salon} from '../../../../types';
import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { deleteSalon,updateSalon,createSalon } from '../../../../../../../crud/management_api/salones';
import { toast } from 'react-toastify';
import { X } from 'react-bootstrap-icons';
import './RenderFunctions.scss';

import MiniLoadingSpinner from '../../../../../../../components/Spinners/MiniLoadingSpinner';


interface SalonDropdownProps {
    salones: Salon[];
    selectedSalon: Salon | undefined;
    onSelectSalon: (salon: Salon | undefined) => void;
  }

  interface RenderSalonEditModalProps {
    salon: Salon;
    onClose: () => void;
    onSave: (salon: Salon) => void;
    salones: Salon[];
    setSalones: (salones: Salon[]) => void;
    setSelectedSalon: (salon: Salon | undefined) => void;
}



export const RenderSalonDropdown: React.FC<SalonDropdownProps> = ({ salones, selectedSalon, onSelectSalon }) => {
  return (
    <div className="salon-selector-container">
        {salones.map((salon, index) => (
            <div
                key={index}
                className={`salon-item ${selectedSalon?.salon_name === salon.salon_name ? 'selected' : ''}`}
                onClick={() => onSelectSalon(salon)}
            >
                {salon.salon_name}
            </div>
        ))}
    </div>
  );
  };


export const RenderSalonEditModal: React.FC<RenderSalonEditModalProps> = ({
  salon,
  onClose,
  onSave,
  salones,
  setSalones,
  setSelectedSalon }) => {
  const [salonName, setSalonName] = useState(salon.salon_name || '');
  const [mesaCapacity, setMesaCapacity] = useState(salon.mesas_capacity || 1);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [description, setDescription] = useState(salon.description || '');
  const [salonState,setSalonState] = useState<boolean>(salon.state ?? true);

  const handleSave = () => {
    const salonData = {
      salon_name: salonName,
      mesas_capacity: mesaCapacity,
      description: description,
      mesas: salon.mesas,
      objetos: salon.objetos,
      state: salonState,
    };
    updateSalon(Number(salon.salon_id), salonData)
      .then((response) => {
        // Si la respuesta es exitosa, actualiza el estado de las mesas según el estado del salón
        const updatedMesas = salon.mesas.map((mesa) => ({
          ...mesa,
          state: salonState,
        }));
        const updatedSalon = { ...salon, ...salonData, mesas: updatedMesas };
        onSave(updatedSalon);
        const newSalones = salones.map((s) =>
          s.salon_id === salon.salon_id ? { ...s, ...salonData, mesas: updatedMesas } : s
        );
        setSalones(newSalones);
        toast.success('Salon actualizado con éxito');
      })
      .catch((error) => {
        toast.error('Error actualizando salón: ' + error.response.data.message);
      });
  };

  const handleDelete = () => {
      deleteSalon(Number(salon.salon_id)).then(() => {
          toast.success('Salon deleted successfully');
          const updatedSalones = salones.filter(s => s.salon_id !== salon.salon_id);
          setSalones(updatedSalones);
          setSelectedSalon(salones.length >= 1 ? salones[0] : undefined);
          onClose();  // Close the edit modal as well
      }).catch(error => {
          toast.error('Error deleting salon: ' + error.message);
      });
  };

  const confirmDelete = () => {
      setShowDeleteConfirm(true);
  };

  const closeDeleteConfirm = () => {
      setShowDeleteConfirm(false);
  };

  return (
      <>
          <Modal className='modal-edit-salon' show={!showDeleteConfirm} onHide={onClose} centered>
              <Modal.Header>
              <div className='form-modal-title-container'>
                  <Modal.Title className='form-modal-title'>Editar salón</Modal.Title>
              </div>
              <Button variant="none" className="modal-close-button" onClick={onClose}>
                <X size={24} /> 
              </Button>
              </Modal.Header>
              <Modal.Body>
                  <Form>
                      <Form.Group controlId="formSalonName" className='mp-formgroup horizontal'>
                          <Form.Label>Nombre</Form.Label>
                          <Form.Control
                              type="text"
                              value={salonName}
                              onChange={(e) => setSalonName(e.target.value)}
                              placeholder="Ingrese el nombre del salón"
                          />
                      </Form.Group>
                      <Form.Group controlId="formSalonName" className='mp-formgroup vertical'>
                          <Form.Label>Descripción</Form.Label>
                          <Form.Control
                              type="text"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              placeholder="Ingrese la descripción del salón"
                          />
                      </Form.Group>
                      <Form.Group controlId="formMesaCapacity" className='mp-formgroup horizontal'>
                          <Form.Label className=''>Capacidad de mesas</Form.Label>
                          <Form.Control
                              type="number"
                              value={mesaCapacity}
                              min={1}
                              
                              onChange={(e) => setMesaCapacity(parseInt(e.target.value))}
                              placeholder="Ingrese la capacidad de mesas"
                          />
                      </Form.Group>
                      <Form.Group controlId="formSalonState" className="mp-formgroup horizontal">
                      <Form.Label>Desactivar/Activar salón</Form.Label>

                      <label className="switch" style={{ marginLeft: '10%' }}>
                        <input
                          id="salonState"
                          type="checkbox"
                          className="toggle-switch-item-checkbox"
                          checked={salonState}
                          onChange={(e) => setSalonState(e.target.checked)}
                        />
                        <span className="slider round"/>
                      </label>

                      <span style={{ marginLeft: 8 }}>{salonState}</span>
                    </Form.Group>
                  </Form>
              </Modal.Body>
              <Modal.Footer>
              <div className="form-modal-footer-custom">
                  <Button className='form-button-delete'variant="none" onClick={confirmDelete}>Eliminar salón</Button>
                  <Button className="form-button-cancel" variant='none' onClick={onClose}>Cancelar</Button>
                  <Button className="form-button-create" variant='none' onClick={handleSave}>Guardar cambios</Button>
              </div>
              </Modal.Footer>
          </Modal>
          {showDeleteConfirm && (
              <Modal show={showDeleteConfirm} onHide={closeDeleteConfirm} centered>
                  <Modal.Header>
                  <div className='form-modal-title-container'>
                      <Modal.Title className='form-modal-title'>Confirmar eliminación</Modal.Title>
                  </div>
                  </Modal.Header>
                  <Modal.Body>
                      Estás seguro de que quieres eliminar este salón?
                  </Modal.Body>
                  <Modal.Footer>
                  <div className="form-modal-footer-custom">
                      <Button className="form-button-cancel" onClick={closeDeleteConfirm}>No</Button>
                      <Button variant="danger" onClick={handleDelete}>Si, eliminar</Button>
                  </div>
                  </Modal.Footer>
              </Modal>
          )}
      </>
  );
};

interface RenderCreateSalonModalProps {
  show: boolean;
  handleClose: (refresh: boolean, createdSalon?: Salon) => void; // Modificado para pasar el salón creado
  salones: Salon[];
  setSalones: (salones: Salon[]) => void;
  setSelectedSalon: (salon: Salon | undefined) => void;
}

export const RenderCreateSalonModal: React.FC<RenderCreateSalonModalProps> =  ({
  show,
  handleClose,
  salones,
  setSalones,
  setSelectedSalon }) => {
  const [salonName, setSalonName] = useState('');
  const [description, setDescription] = useState('');
  const [mesasCapacity, setMesasCapacity] = useState(0);
  const [loading, setLoading] = useState(false); // Nuevo estado

  const handleSubmit = async () => {
    setLoading(true); // Inicia el spinner
    const user = localStorage.getItem('user');
    const localId = user ? JSON.parse(user).local_id : 0;
    let salonData = {
      salon_name: salonName,
      description: description,
      mesas_capacity: mesasCapacity,
      local_id: localId,
      state: true,
      mesas: [],
      objetos: [],
      salon_id: '', // inicializa vacío
    };
    createSalon(salonData).then((response) => {
      // Usa el salon_id del objeto salon en la respuesta
      const createdSalon = {
        ...salonData,
        ...response.data.salon, // esto incluye el salon_id correcto
        mesas: [],
        objetos: []
      };
      setSalones([...salones, createdSalon]);
      setSelectedSalon(createdSalon);
      toast.success('Salon created successfully!');
      handleClose(true, createdSalon);
    }).catch(error => {
      toast.error('Failed to create salon: ' + (error.response?.data?.message || error.message));
    }).finally(() => setLoading(false)); // Detiene el spinner
  }

  return (
    <Modal className='modal-create-salon' show={show} onHide={() => handleClose(false)}>
      <Modal.Header>
      <div className='form-modal-title-container'>
        <Modal.Title className='form-modal-title'>Crear un salón</Modal.Title>
      </div>
      <Button variant="none" className="modal-close-button" onClick={() => handleClose(false)}>
          <X size={24} /> 
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="salonName" className='mp-formgroup vertical'>
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingresa el nombre del salón"
              value={salonName}
              onChange={e => setSalonName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="description" className='mp-formgroup vertical'>
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingresa una descripción del salón"
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
      <div className="form-modal-footer-custom">
        <Button className="form-button-cancel" onClick={() => handleClose(false)}>
          Cancelar
        </Button>
        {loading ? (
          <MiniLoadingSpinner left="0" />
        ) : (
          <Button className="form-button-create" onClick={handleSubmit}>
            Crear salón
          </Button>
        )}
      </div>
      </Modal.Footer>
    </Modal>
  );
};




